/*
 * Copyright (c) Nexign, JSC, 2019.
 */

/**
 *
 * @author Fedorov Maxim
 * @version 1.0.1
 * @since 1.0.1
 */
import { MouseEvent, ReactElement } from 'react';

import { TabBtnStyled } from './tabStyled';

interface ITab {
    children?: ReactElement;
    className?: string;
    index?: number;
    label: string;
    onClick?: (e: MouseEvent<HTMLDivElement>) => void;
}

const Tab = (props: ITab) => {
    return (
        <TabBtnStyled
            className={props.className}
            data-index={props.index}
            key={props.label}
            onClick={props.onClick}
        >
            {props.label}
        </TabBtnStyled>
    );
};

export default Tab;
